const JST_OFFSET_MS = 9 * 60 * 60 * 1000;

/**
 * 数値を指定桁数のゼロ埋め文字列へ整形する
 * @param value 整形対象の数値
 * @param length 桁数
 * @return ゼロ埋め後の文字列
 */
const padNumber = (value: number, length = 2) => {
  return String(value).padStart(length, "0");
};

/**
 * DateをJST基準の日時へ変換する
 * @param value 変換対象の日時
 * @return JSTへ補正した日時
 */
const toJstDate = (value: Date) => {
  return new Date(value.getTime() + JST_OFFSET_MS);
};

/**
 * 画面表示向けにJSTの日時文字列へ整形する
 * @param value 日時
 * @return 表示用の日時文字列
 */
export const formatDateTimeForDisplay = (value: Date | null) => {
  if (!value) {
    return "-";
  }

  const date = toJstDate(value);

  return `${date.getUTCFullYear()}/${padNumber(date.getUTCMonth() + 1)}/${padNumber(date.getUTCDate())} ${padNumber(date.getUTCHours())}:${padNumber(date.getUTCMinutes())}:${padNumber(date.getUTCSeconds())}`;
};

/**
 * ファイル名向けにJSTの日時文字列へ整形する
 * @param value 日時
 * @return ファイル名用の日時文字列
 */
export const formatDateTimeForFileName = (value: Date) => {
  const date = toJstDate(value);

  // 例) 20260324111210
  return `${date.getUTCFullYear()}${padNumber(date.getUTCMonth() + 1)}${padNumber(date.getUTCDate())}${padNumber(date.getUTCHours())}${padNumber(date.getUTCMinutes())}${padNumber(date.getUTCSeconds())}`;
};
